import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.string.includes";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { emojiQQ } from '@/const/emojiMap';
import { debounce } from 'lodash';
import { mapGetters } from 'vuex';
var imui = null;
export default {
  meta: {
    title: '客服中心',
    auth: true,
    cache: true,
    authorityValue: 'store-router-page'
  },
  name: 'chat',
  data: function data() {
    return {
      emojiQQ: emojiQQ,
      initData: {
        width: '100%',
        height: '100%',
        hideMessageTime: true,
        hideMessageName: true
      },
      user: {},
      nextSeq: 0,
      conversationList: [],
      currentChatId: '',
      chatLogs: [],
      end: false,
      lastMsgId: null,
      propr: false,
      drawer: false,
      drawerList: ['为什么物流一直没更新'],
      videoSrc: '',
      dialogVisible: false,
      isLoading: []
    };
  },
  onShow: function onShow() {// this.currentChatId = ''
    // this.end = false
    // this.lastMsgId = null
  },
  computed: _objectSpread({
    TXIM: function TXIM() {
      return YL.txim;
    }
  }, mapGetters('d2admin', {
    isImShow: 'message/isImShow'
  })),
  methods: {
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.videoUrl = '';
    },
    messageClick: function messageClick(event, key, Message, instance) {
      var type = Message.type,
          content = Message.content;

      switch (type) {
        case 'image':
          this.openImageView(content);
          break;

        case 'video':
          this.videoSrc = Message.videoUrl;
          this.dialogVisible = true;
          break;

        default:
          break;
      }
    },
    clickEmoji: function clickEmoji(item) {
      var val = imui.getEditorValue();
      imui.setEditorValue(val + '' + item);
      this.drawer && !this.drawer;
    },
    handleFocusOut: function handleFocusOut() {
      console.log('关闭了');
      this.propr = false; // do something here
    },
    onProfileUpdated: function onProfileUpdated(e) {
      console.log(e, '监听到好友信息改变');
    },
    onFriendListUpdated: function onFriendListUpdated(e) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log(e, '监听到好友列表改变');

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    onConversationHandler: function onConversationHandler(e) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var conversationList;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this.currentChatId) {
                  _context2.next = 3;
                  break;
                }

                _context2.next = 3;
                return _this.TXIM.markC2CMessageAsRead(_this.currentChatId);

              case 3:
                conversationList = e.data.sort(function (a, b) {
                  return b.lastMessage.lastTime - a.lastMessage.lastTime;
                });
                _this.conversationList = conversationList.map(function (v) {
                  return {
                    id: v.conversationID,
                    displayName: v.userProfile.nick || '客服',
                    avatar: v.userProfile.avatar || _this.VUE_APP_ICON_IMG,
                    index: '联系人',
                    unread: v.unreadCount,
                    //最近一条消息的内容，如果值为空，不会出现在“聊天”列表里面。
                    //lastContentRender 函数会将 file 消息转换为 '[文件]', image 消息转换为 '[图片]'，对 text 会将文字里的表情标识替换为img标签,
                    lastContent: imui.lastContentRender(_this.TXIM.setMessageType(v.lastMessage)),
                    //最近一条消息的发送时间
                    lastSendTime: v.lastMessage.lastTime * 1000
                  };
                }).filter(function (x) {
                  return x.id.indexOf('C2Ca_') == -1 || x.id.indexOf('custom_service') !== -1;
                });
                imui.initContacts(_this.conversationList);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    onRecvMessageHanlder: function onRecvMessageHanlder(e) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var msg, data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log(e, '监听到新的消息');
                msg = e.data[0]; //接收者id

                if (!(_this2.currentChatId && msg.conversationID == _this2.currentChatId)) {
                  _context3.next = 5;
                  break;
                }

                _context3.next = 5;
                return _this2.TXIM.markC2CMessageAsRead(_this2.currentChatId);

              case 5:
                //将接收到的数据包装成下面的样子
                data = _objectSpread({
                  id: msg.ID,
                  status: msg.status,
                  sendTime: msg.time * 1000,
                  toContactId: msg.conversationID,
                  fromUser: {
                    //如果 id == this.user.id消息会显示在右侧，否则在左侧
                    id: msg.from,
                    displayName: msg.nick,
                    avatar: msg.avatar || _this2.VUE_APP_ICON_IMG
                  }
                }, _this2.TXIM.setMessageType(msg));
                imui.appendMessage(data);
                imui.messageViewToBottom();

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    //获取会话列表
    getConversationList: function getConversationList() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _yield$_this3$TXIM$ge, data, conversationList;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this3.TXIM.getConversationList();

              case 2:
                _yield$_this3$TXIM$ge = _context4.sent;
                data = _yield$_this3$TXIM$ge.data;
                data.conversationList = data.conversationList || data.conversations;
                conversationList = data.conversationList.sort(function (a, b) {
                  return b.lastMessage.lastTime - a.lastMessage.lastTime;
                });
                _this3.conversationList = conversationList.map(function (v) {
                  return {
                    id: v.conversationID,
                    displayName: v.userProfile.nick || '客服',
                    avatar: v.userProfile.avatar || _this3.VUE_APP_ICON_IMG,
                    index: '联系人',
                    unread: v.unreadCount,
                    //最近一条消息的内容，如果值为空，不会出现在“聊天”列表里面。
                    //lastContentRender 函数会将 file 消息转换为 '[文件]', image 消息转换为 '[图片]'，对 text 会将文字里的表情标识替换为img标签,
                    lastContent: imui.lastContentRender(_this3.TXIM.setMessageType(v.lastMessage)),
                    //最近一条消息的发送时间
                    lastSendTime: v.lastMessage.lastTime * 1000
                  };
                }).filter(function (x) {
                  return x.id.indexOf('C2Ca_') == -1;
                });
                _context4.next = 9;
                return _this3.$nextTick();

              case 9:
                imui.initContacts(_this3.conversationList);

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    //获取历史消息
    getLogs: function getLogs() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _yield$_this4$TXIM$ge, data;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this4.TXIM.getC2CHistoryMessageList(_this4.currentChatId, 20, _this4.lastMsgId);

              case 2:
                _yield$_this4$TXIM$ge = _context5.sent;
                data = _yield$_this4$TXIM$ge.data;
                _this4.lastMsgId = data.nextReqMessageID;
                _this4.end = data.isCompleted;
                return _context5.abrupt("return", data.messageList);

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    toChat: debounce( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(item) {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.getLogs();

              case 2:
                return _context6.abrupt("return", _context6.sent);

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }(), 500, {
      leading: true,
      trailing: false
    }),
    // 发送文字
    sendText: debounce( /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(text, type, next) {
        var V2TIMMessageManager, v2TIMMessage;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                V2TIMMessageManager = this.TXIM.getInstance();
                _context7.next = 3;
                return V2TIMMessageManager.createTextMessage(this.currentChatId, text);

              case 3:
                v2TIMMessage = _context7.sent;
                _context7.prev = 4;
                _context7.next = 7;
                return V2TIMMessageManager.sendMessage(v2TIMMessage);

              case 7:
                console.log('发送成功', v2TIMMessage);
                next({
                  id: v2TIMMessage.ID,
                  status: 'success',
                  type: 'textdir',
                  isPeerRead: v2TIMMessage.isPeerRead
                });
                _context7.next = 14;
                break;

              case 11:
                _context7.prev = 11;
                _context7.t0 = _context7["catch"](4);
                YL.message('发送失败', 'error');

              case 14:
                _context7.next = 16;
                return this.$nextTick();

              case 16:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[4, 11]]);
      }));

      return function (_x2, _x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }(), 500, {
      leading: true,
      trailing: false
    }),
    handleSend: function handleSend(message, next, file) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return _this5.sendText(message.content, message.type, next);

              case 2:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    },
    changeContact: function changeContact(contact) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var loading;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!_this6.isLoading.includes(contact.id)) {
                  loading = _this6.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                  });
                  setTimeout(function () {
                    loading.close();
                  }, 500);
                }

                _this6.lastMsgId = null;
                _this6.end = false;
                _this6.currentChatId = contact.id;

                _this6.isLoading.push(contact.id);

                _context9.next = 7;
                return _this6.TXIM.markC2CMessageAsRead(contact.id);

              case 7:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }))();
    },
    handlePullMessages: function handlePullMessages(contact, next) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var data, messages;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return _this7.toChat(contact);

              case 2:
                data = _context10.sent;
                messages = data.map(function (v) {
                  if (!v.avatar || !isNaN(v.avatar)) v.avatar = '';
                  return _objectSpread({
                    id: v.ID,
                    status: v.status,
                    sendTime: v.time * 1000,
                    toContactId: contact.id,
                    fromUser: {
                      id: v.from,
                      displayName: v.nick,
                      avatar: v.avatar
                    }
                  }, _this7.TXIM.setMessageType(v));
                }); // await this.HistoryMessageToChatLog(data, 'unshift')
                //参数设为true，表示已到末尾，聊天窗口顶部会显示“暂无更多消息”

                next(messages, _this7.end);

              case 5:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }))();
    },
    //初始化工具栏
    initTool: function initTool() {
      var _this8 = this;

      var h = this.$createElement;
      // { name: 'uploadFile' }, { name: 'uploadImage' }
      var tool = [];
      var emojiTool = {
        name: 'emojiTool',
        isRight: false,
        title: '选择表情',
        click: function click() {
          _this8.propr = !_this8.propr;
        },
        render: function render() {
          return h("d2-icon-svg", {
            "attrs": {
              "name": "d2-emoji"
            },
            "style": "width:20px;height:26px;fill:#999"
          });
        }
      };
      tool.push(emojiTool);
      var more = {
        name: 'oldText',
        isRight: true,
        title: '常用语',
        click: function click() {
          _this8.drawer = true;
        },
        render: function render() {
          return '...';
        }
      };
      tool.push(more);
      imui.initEditorTools(tool);
      var emoji = emojiQQ.map(function (v) {
        return {
          name: v,
          title: v,
          src: ''
        };
      });
      imui.initEmoji(emoji);
      imui.setLastContentRender('video', function (message) {
        return h("span", ["[\u89C6\u9891]"]);
      });
      imui.setLastContentRender('textdir', function (message) {
        return h("span", [message.content]);
      });
    },
    getMyProfile: function getMyProfile() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var data;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return _this9.TXIM.getMyProfile();

              case 2:
                data = _context11.sent;
                _this9.user = {
                  id: data.userID,
                  displayName: data.nick,
                  avatar: data.avatar || _this9.VUE_APP_ICON_IMG
                };

              case 4:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }))();
    },
    onReadByPeerHandler: function onReadByPeerHandler(message) {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                console.log('收到消息已读回执', message);
                message.data.forEach(function (x) {
                  imui.updateMessage(_objectSpread({
                    id: x.ID
                  }, _this10.TXIM.setMessageType(_objectSpread({}, x))));
                });
                imui.forceUpdateMessage();

              case 3:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }))();
    },
    init: function init() {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var IMUI;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return _this11.getMyProfile();

              case 2:
                IMUI = _this11.$refs.IMUI;
                imui = IMUI;

                _this11.initTool(); // 监听会话列表的消息


                _this11.TXIM.$on('CONVERSATION_LIST_UPDATED', _this11.onConversationHandler); // 监听新的消息


                _this11.TXIM.$on('MESSAGE_RECEIVED', _this11.onRecvMessageHanlder);

                _this11.TXIM.$on('MESSAGE_READ_BY_PEER', _this11.onReadByPeerHandler); // 自己或好友的资料发生变更时触发，event.data 是包含 Profile 对象的数组
                // this.TXIM.$on('PROFILE_UPDATED', this.onProfileUpdated)
                // 好友列表更新时触发
                // this.TXIM.$on('MESSAGE_READ_BY_PEER', this.onFriendListUpdated)


                _this11.getConversationList();

              case 9:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }))();
    }
  },
  mounted: function mounted() {
    this.init();
  }
};